var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('VouchersClientsTable',{staticClass:"pb-4",scopedSlots:_vm._u([{key:"actions",fn:function({ dataset }){return [_c('avs-exportButton',{attrs:{"data":dataset,"prepare":_vm.preFmtData,"name":_vm.$t('actions.export_'),"spantext":_vm.$t('actions.export', { entity: _vm.$t('bons clients') })}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }